import Feed from "./Feed";
import SideBar from "./SideBar";
import Widget from "./Widget";
import TopNavigation from '../top-navigation/TopNavigation'
import BottomNavigation from '../bottom-navigation/BottomNavigation'
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { applicationassigned } from "../../features/Applicant/applicantSlice";



const Dashboard = () => {
	const navigate = useNavigate();
	const dispatch = useAppDispatch();
	// @ts-ignore
	const userInfo = JSON.parse(localStorage.getItem("user_ats"));
	useEffect(() => {
		if (!userInfo) {
			navigate('/')
		}
	}, [navigate, userInfo])

	// const [showModal, setShowModal]: any = useState(false);
	// @ts-ignore
	const loginSuccess = JSON.parse(localStorage.getItem("loginToast"));
	const { applicationassigneddata,
		applicationassignedisLoading,
	} = useAppSelector((state: any) => state.applicant)



	useEffect(() => {
		dispatch(applicationassigned())
	}, [dispatch])

	useEffect(() => {
		if (loginSuccess) {
			toast.success("Login Successfully!");
			setTimeout(() => {
				localStorage.setItem("loginToast", JSON.stringify(false));
			}, 1000);
		}
	}, [loginSuccess]);

	return (
		<div className="screen-wrapper">
			<Toaster
				position="top-center"
				toastOptions={{
					duration: 5000,
					error: {
						duration: 10000,
					},

				}}
			/>
			<TopNavigation />
			<div className="app_body">
				<SideBar />
				<div className="app_feed_widget">
					{/* @ts-ignore */}
					<Feed name={""} />
					<Widget applicationassigneddata={applicationassigneddata?.data} isLoading={applicationassignedisLoading} />
				</div>
			</div>
			<BottomNavigation />
		</div>
	)
}

export default Dashboard